"use client";
import React, { useState } from "react";
import countryCodes from "./countrycode.json";
import InternationalRateCalculatorFormUI from "./InternationalRateCalculatorFormUI";
import API_URLS from './apiUrls';

export default function InternationalRateCalculatorForm() {
  const countryOptions = countryCodes.map((country) => ({
    value: country.id,
    label: country.name,
  }));
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [form, setForm] = useState({
    pickup_pincode: "",
    delivery_pincode: "",
    delivery_country_id: "",
    order_amount: "",
    type_of_package: "", // Default value MPS
    shipment_purpose: "",
    weight: "",
    dimensions: [
      {
        no_of_box: "", // Default value
        length: "",
        width: "",
        height: "",
      },
    ],
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [apiError, setApiError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (["length", "width", "height", "no_of_box"].includes(name)) {
      setForm((prev) => ({
        ...prev,
        dimensions: [
          {
            ...prev.dimensions[0],
            [name]: value,
          },
        ],
      }));
    } else if (name === "type_of_package") {
      // If Single Package selected, set no_of_box to '1'
      setForm((prev) => ({
        ...prev,
        type_of_package: value,
        dimensions: [
          {
            ...prev.dimensions[0],
            no_of_box: value === "SPS" ? "1" : prev.dimensions[0].no_of_box,
          },
        ],
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCountryChange = (option) => {
    setForm((prev) => ({
      ...prev,
      delivery_country_id: option.value,
    }));
    setSelectedCountry(option);
  };

  const validate = () => {
    const newErrors = {};
    if (!form.pickup_pincode)
      newErrors.pickup_pincode = "Pickup Pincode is required";
    if (!form.delivery_country_id)
      newErrors.delivery_country_id = "Delivery Country is required";
    if (!form.order_amount) newErrors.order_amount = "Order Amount is required";
    if (!form.shipment_purpose)
      newErrors.shipment_purpose = "Shipment Purpose is required";
    if (!form.weight) newErrors.weight = "Weight is required";
    if (!form.dimensions[0].length) newErrors.length = "Length is required";
    if (!form.dimensions[0].width) newErrors.width = "Width is required";
    if (!form.dimensions[0].height) newErrors.height = "Height is required";
    return newErrors;
  };

  const handleSubmit = async () => {
    setApiError("");
    setApiResponse(null);
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;
    setLoading(true);
    try {
      const payload = {
        pickup_pincode: parseInt(form.pickup_pincode),
        delivery_pincode: form.delivery_pincode
          ? parseInt(form.delivery_pincode)
          : parseInt(form.pickup_pincode),
        delivery_country_id: parseInt(form.delivery_country_id),
        order_amount: parseInt(form.order_amount),
        type_of_package: form.type_of_package,
        shipment_purpose: form.shipment_purpose,
        weight: parseFloat(form.weight) * 1000,
        dimensions: [
          {
            no_of_box: form.dimensions[0].no_of_box,
            length: form.dimensions[0].length,
            width: form.dimensions[0].width,
            height: form.dimensions[0].height,
          },
        ],
      };
      const response = await fetch(API_URLS.internationalRates, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || response.statusText);
      }
      const data = await response.json();
      setApiResponse(data);
    } catch (err) {
      console.log("API error:", err);
      setApiError(err.message || "API Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <InternationalRateCalculatorFormUI
        form={form}
        errors={errors}
        loading={loading}
        apiError={apiError}
        apiResponse={apiResponse}
        countryOptions={countryOptions}
        selectedCountry={selectedCountry}
        handleInputChange={handleInputChange}
        handleCountryChange={handleCountryChange}
        handleSubmit={handleSubmit}
      />

      {/* <div>
        {apiResponse &&
          apiResponse.data &&
          Array.isArray(apiResponse.data.data) &&
          apiResponse.data.data.length > 0 && (
            <div className="mt-6">
              <InternationalRateResultTable rates={apiResponse.data.data} />
            </div>
          )}
      </div> */}
    </>
  );
}
